(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["havn-product-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-hvn-hero]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    const slides=[...root.querySelectorAll('[data-hvn-slide]')];
    const thumbs=[...root.querySelectorAll('[data-hvn-thumb]')];
    let idx=0;

    const show=i=>{
      if(!slides.length)return;
      idx=(i+slides.length)%slides.length;
      slides.forEach((s,n)=>{s.hidden=n!==idx;s.classList.toggle('is-active',n===idx)});
      thumbs.forEach((t,n)=>t.classList.toggle('is-active',n===idx));
    };

    root.querySelector('[data-hvn-prev]')?.addEventListener('click',()=>show(idx-1));
    root.querySelector('[data-hvn-next]')?.addEventListener('click',()=>show(idx+1));
    thumbs.forEach(t=>t.addEventListener('click',()=>show(Number(t.dataset.hvnThumb))));

    const variants=JSON.parse(root.querySelector('[data-hvn-variants]')?.textContent||'[]');
    const idInput=root.querySelector('[data-hvn-variant-id]');
    const atc=root.querySelector('[data-hvn-atc]');
    const atcText=root.querySelector('[data-hvn-atc-text]');

    const refreshVariant=()=>{
      const fields=[...root.querySelectorAll('[data-hvn-option]')];
      if(!fields.length)return;
      const selected=fields.map(f=>f.querySelector('[data-hvn-option-input]:checked')?.value);
      const match=variants.find(v=>v.options.every((o,i)=>o===selected[i]));
      if(!match){if(atc)atc.disabled=true;if(atcText)atcText.textContent='Unavailable';return}
      if(idInput)idInput.value=match.id;
      if(atc)atc.disabled=!match.available;
      if(atcText)atcText.textContent=match.available?'{{ section.settings.atc_text | escape }}':'Sold out';
    };

    root.querySelectorAll('[data-hvn-option-input]').forEach(i=>i.addEventListener('change',refreshVariant));

    root.querySelectorAll('[data-hvn-bundle]').forEach(btn=>btn.addEventListener('click',()=>{
      root.querySelectorAll('[data-hvn-bundle]').forEach(x=>x.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      const vid=btn.dataset.variantId;
      if(vid && /^\d+$/.test(vid) && idInput) idInput.value=vid;
    }));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["house-number-product-offer"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const initHouseOffer = root => {
    if(!root || root.dataset.houseNumberReady==='1') return;
    root.dataset.houseNumberReady='1';

    const slides=[...root.querySelectorAll('[data-r-slide]')];
    const thumbs=[...root.querySelectorAll('[data-r-thumb]')];
    let idx=0;

    const show=i=>{
      if(!slides.length)return;
      idx=(i+slides.length)%slides.length;
      slides.forEach((s,n)=>s.hidden=n!==idx);
      thumbs.forEach((t,n)=>t.classList.toggle('active',n===idx));
    };

    root.querySelector('[data-r-prev]')?.addEventListener('click',()=>show(idx-1));
    root.querySelector('[data-r-next]')?.addEventListener('click',()=>show(idx+1));
    thumbs.forEach(t=>t.addEventListener('click',()=>show(Number(t.dataset.rThumb))));

    const plans=[...root.querySelectorAll('[data-r-plan]')];
    const selectors=[...root.querySelectorAll('[data-house-number-selector]')];
    const atc=root.querySelector('[data-r-atc]');
    const atcText=root.querySelector('[data-r-atc-text]');
    const hiddenId=root.querySelector('[data-r-variant-id]');

    const propertyLabel=root.dataset.cartPropertyLabel || 'House Numbers';
    const selectorEnabled=root.dataset.selectorEnabled === 'true';

    const isValidId=value => !!value && /^\d+$/.test(String(value)) && String(value)!=='0';

    let selectedPlan=
      plans.find(p=>p.classList.contains('selected') && !p.disabled) ||
      plans.find(p=>!p.disabled) ||
      null;

    const activeSelector=()=>{
      if(!selectedPlan) return null;
      return selectors.find(s=>s.dataset.selectorFor===selectedPlan.dataset.blockId) || null;
    };

    const refreshSelector=selector=>{
      if(!selector) return;

      const count=parseInt(selector.dataset.selectorCount || '0',10);
      const slots=[...selector.querySelectorAll('[data-digit-slot]')];
      const selects=[...selector.querySelectorAll('[data-house-digit]')];
      const preview=selector.querySelector('[data-house-preview]');
      const previewValue=selector.querySelector('[data-house-preview-value]');
      const errorBox=selector.querySelector('[data-house-number-error]');

      slots.forEach((slot,index)=>{
        const visible=index<count;
        slot.hidden=!visible;
        slot.style.display=visible ? '' : 'none';
        if(selects[index]){
          selects[index].required=visible;
          if(!visible) selects[index].value='';
        }
      });

      const digits=selects.slice(0,count).map(s=>s.value);

      if(preview && previewValue){
        preview.hidden=!digits.some(Boolean);
        previewValue.textContent=digits.map(d=>d||'–').join('');
      }

      if(errorBox) errorBox.hidden=true;
    };

    const selectPlan=plan=>{
      if(!plan || plan.disabled) return;

      selectedPlan=plan;

      plans.forEach(p=>{
        const active=p===plan;
        p.classList.toggle('selected',active);
        p.setAttribute('aria-pressed',active ? 'true' : 'false');
      });

      selectors.forEach(selector=>{
        const active=selector.dataset.selectorFor===plan.dataset.blockId;
        selector.hidden=!active;
        if(active) refreshSelector(selector);
      });

      const variantId=plan.dataset.variantId;
      if(hiddenId && isValidId(variantId)){
        hiddenId.value=variantId;
        hiddenId.setAttribute('value',variantId);
      }
    };

    plans.forEach(plan=>{
      plan.addEventListener('click',event=>{
        event.preventDefault();
        selectPlan(plan);
      });
    });

    selectors.forEach(selector=>{
      selector.querySelectorAll('[data-house-digit]').forEach(select=>{
        select.addEventListener('change',()=>refreshSelector(selector));
      });
    });

    if(selectedPlan) selectPlan(selectedPlan);

    atc?.addEventListener('click',async event=>{
      event.preventDefault();
      event.stopPropagation();

      if(!selectedPlan || selectedPlan.disabled){
        alert('Please select an available offer.');
        return;
      }

      const variantId=selectedPlan.dataset.variantId;

      if(!isValidId(variantId)){
        alert('This offer is missing its Shopify variant ID.');
        return;
      }

      const selector=activeSelector();
      let digits=[];

      if(selectorEnabled && selector){
        const count=parseInt(selector.dataset.selectorCount || '0',10);
        const selects=[...selector.querySelectorAll('[data-house-digit]')].slice(0,count);
        digits=selects.map(s=>s.value);

        if(!digits.length || digits.some(v=>!v)){
          const errorBox=selector.querySelector('[data-house-number-error]');
          if(errorBox) errorBox.hidden=false;
          selects.find(s=>!s.value)?.focus();
          return;
        }
      }

      const originalText=atcText?.textContent || 'ADD TO CART';
      atc.disabled=true;
      atc.setAttribute('aria-busy','true');
      if(atcText) atcText.textContent='ADDING...';

      const item={
        id:Number(variantId),
        quantity:1
      };

      if(selectorEnabled && digits.length){
        item.properties={};
        item.properties[propertyLabel || 'House Numbers']=digits.join('');
      }

      try{
        const response=await fetch(
          window.Shopify?.routes?.root
            ? window.Shopify.routes.root + 'cart/add.js'
            : '/cart/add.js',
          {
            method:'POST',
            headers:{
              'Content-Type':'application/json',
              'Accept':'application/json'
            },
            body:JSON.stringify({items:[item]})
          }
        );

        const payload=await response.json().catch(()=>({}));

        if(!response.ok){
          throw new Error(payload.description || payload.message || 'Unable to add this offer to cart.');
        }

        window.location.href=
          window.Shopify?.routes?.root
            ? window.Shopify.routes.root + 'cart'
            : '/cart';
      }catch(error){
        console.error('[House number cart error]',error);
        if(atcText) atcText.textContent=originalText;
        atc.disabled=false;
        atc.removeAttribute('aria-busy');
        alert(error.message || 'Unable to add this offer to cart.');
      }
    });
  };

  document.querySelectorAll('[data-r-offer]').forEach(initHouseOffer);
  document.addEventListener('shopify:section:load',event=>{
    event.target.querySelectorAll?.('[data-r-offer]').forEach(initHouseOffer);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infinity-compare"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-inf-compare]').forEach(root=>{
  root.querySelectorAll('[data-tab]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      root.querySelectorAll('[data-tab]').forEach(x=>x.classList.toggle('is-active',x===btn));
      root.querySelectorAll('[data-panel]').forEach(p=>p.classList.toggle('is-hidden',p.dataset.panel!==btn.dataset.tab));
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infinity-product-offer"] && !Shopify.designMode) return;
  try {
    

(() => {

  document
    .querySelectorAll('[data-inf-offer]')
    .forEach(root => {

      if (root.dataset.ready) return;

      root.dataset.ready = '1';


      const slides =
        [...root.querySelectorAll('[data-slide]')];

      const dots =
        [...root.querySelectorAll('[data-dot]')];

      let idx = 0;


      const show = i => {

        if (!slides.length) return;

        idx =
          (i + slides.length)
          % slides.length;


        slides.forEach(
          (slide, n) => {

            slide.hidden =
              n !== idx;

            slide.classList.toggle(
              'is-active',
              n === idx
            );

          }
        );


        dots.forEach(
          (dot, n) => {

            dot.classList.toggle(
              'is-active',
              n === idx
            );

          }
        );

      };


      root
        .querySelector('[data-prev]')
        ?.addEventListener(
          'click',
          () => show(idx - 1)
        );


      root
        .querySelector('[data-next]')
        ?.addEventListener(
          'click',
          () => show(idx + 1)
        );


      dots.forEach(
        dot => {

          dot.addEventListener(
            'click',
            () =>
              show(
                Number(dot.dataset.dot)
              )
          );

        }
      );


      const variants =
        JSON.parse(
          root
            .querySelector('[data-variants]')
            ?.textContent
          || '[]'
        );


      const idInput =
        root.querySelector(
          '[data-variant-id]'
        );


      const atc =
        root.querySelector(
          '[data-atc]'
        );


      const atcText =
        root.querySelector(
          '[data-atc-text]'
        );


      const refreshVariant = () => {

        const optionFields =
          [
            ...root.querySelectorAll(
              '.inf-offer__option'
            )
          ];


        if (!optionFields.length) {
          return;
        }


        const selected =
          optionFields.map(
            fieldset =>
              fieldset
                .querySelector(
                  '[data-option-input]:checked'
                )
                ?.value
          );


        const match =
          variants.find(
            variant =>
              variant.options.every(
                (option, index) =>
                  option === selected[index]
              )
          );


        if (!match) {

          if (atc) {
            atc.disabled = true;
          }

          if (atcText) {
            atcText.textContent =
              'Unavailable';
          }

          return;
        }


        if (idInput) {
          idInput.value =
            match.id;
        }


        if (atc) {
          atc.disabled =
            !match.available;
        }


        if (atcText) {

          atcText.textContent =
            match.available
              ? '{{ section.settings.atc_label | escape }}'
              : 'Sold out';

        }


        const url =
          new URL(
            window.location.href
          );


        url.searchParams.set(
          'variant',
          match.id
        );


        window.history.replaceState(
          {},
          '',
          url
        );

      };


      root
        .querySelectorAll(
          '[data-option-input]'
        )
        .forEach(
          input => {

            input.addEventListener(
              'change',
              refreshVariant
            );

          }
        );


      root
        .querySelectorAll(
          '[data-plan]'
        )
        .forEach(
          plan => {

            plan.addEventListener(
              'click',
              () => {

                root
                  .querySelectorAll(
                    '[data-plan]'
                  )
                  .forEach(
                    other =>
                      other
                        .classList
                        .remove(
                          'is-selected'
                        )
                  );


                plan
                  .classList
                  .add(
                    'is-selected'
                  );

              }
            );

          }
        );

    });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["relief-product-offer"] && !Shopify.designMode) return;
  try {
    
(()=>{
  document.querySelectorAll('[data-r-offer]').forEach(root=>{
    if(root.dataset.rBundleReady==='1') return;
    root.dataset.rBundleReady='1';

    const slides=[...root.querySelectorAll('[data-r-slide]')];
    const thumbs=[...root.querySelectorAll('[data-r-thumb]')];
    let idx=0;

    const show=i=>{
      if(!slides.length)return;
      idx=(i+slides.length)%slides.length;
      slides.forEach((s,n)=>s.hidden=n!==idx);
      thumbs.forEach((t,n)=>t.classList.toggle('active',n===idx));
    };

    root.querySelector('[data-r-prev]')?.addEventListener('click',()=>show(idx-1));
    root.querySelector('[data-r-next]')?.addEventListener('click',()=>show(idx+1));
    thumbs.forEach(t=>t.addEventListener('click',()=>show(Number(t.dataset.rThumb))));

    const plans=[...root.querySelectorAll('[data-r-plan]')];
    const atc=root.querySelector('[data-r-atc]');
    const atcText=root.querySelector('[data-r-atc-text]');
    const hiddenId=root.querySelector('[data-r-variant-id]');

    const isValidId=value => !!value && /^\d+$/.test(String(value)) && String(value)!=='0';

    let selectedPlan =
      plans.find(p=>p.classList.contains('selected') && !p.disabled) ||
      plans.find(p=>!p.disabled) ||
      null;

    const selectPlan=plan=>{
      if(!plan || plan.disabled)return;

      selectedPlan=plan;

      plans.forEach(p=>{
        p.classList.toggle('selected',p===plan);
        p.setAttribute('aria-pressed',p===plan ? 'true' : 'false');
      });

      const variantId=plan.dataset.variantId;

      if(hiddenId && isValidId(variantId)){
        hiddenId.value=variantId;
        hiddenId.setAttribute('value',variantId);
      }
    };

    plans.forEach(plan=>{
      plan.addEventListener('click',event=>{
        event.preventDefault();
        selectPlan(plan);
      });
    });

    if(selectedPlan) selectPlan(selectedPlan);

    atc?.addEventListener('click',async event=>{
      event.preventDefault();
      event.stopPropagation();

      if(!selectedPlan || selectedPlan.disabled){
        alert('Please select an available offer.');
        return;
      }

      const variantId=selectedPlan.dataset.variantId;

      if(!isValidId(variantId)){
        alert('This offer is missing its Shopify variant ID.');
        return;
      }

      const originalText=atcText?.textContent || 'ADD TO CART';

      atc.disabled=true;
      atc.setAttribute('aria-busy','true');
      if(atcText) atcText.textContent='ADDING...';

      try{
        const response=await fetch(window.Shopify?.routes?.root
          ? window.Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js',{
          method:'POST',
          headers:{
            'Content-Type':'application/json',
            'Accept':'application/json'
          },
          body:JSON.stringify({
            items:[{
              id:Number(variantId),
              quantity:1
            }]
          })
        });

        const payload=await response.json().catch(()=>({}));

        if(!response.ok){
          throw new Error(payload.description || payload.message || 'Unable to add this offer to cart.');
        }

        window.location.href=window.Shopify?.routes?.root
          ? window.Shopify.routes.root + 'cart'
          : '/cart';
      }catch(error){
        console.error('[Relief offer cart error]',error);
        if(atcText) atcText.textContent=originalText;
        atc.disabled=false;
        atc.removeAttribute('aria-busy');
        alert(error.message || 'Unable to add this offer to cart.');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
